import { render, staticRenderFns } from "./CardSelection.vue?vue&type=template&id=02885894"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports